import { Inject, Injectable, Type } from '@angular/core'
import { Dialog } from '@angular/cdk/dialog'
import { Overlay } from '@angular/cdk/overlay'
import { Observable } from 'rxjs'
import { YesNoDialogComponent } from '../../shared/dialogs/yes-no-dialog.component'
import { SimpleDialogComponent } from '../../shared/dialogs/simple-dialog.component'
import { YesNoCancelDialogComponent } from '../../shared/dialogs/yes-no-cancel-dialog.component'
import { DateSelectDialogComponent } from '../../shared/dialogs/date-select-dialog/date-select-dialog.component'
import { CuzkLoginDialogComponent } from '../../domain/cadastral/dialogs/cuzk-login-dialog/cuzk-login-dialog.component'

@Injectable({
    providedIn: 'root',
})
export class DialogService {

    constructor(@Inject(Dialog) private dialog: Dialog,
                @Inject(Overlay) private overlay: Overlay) {
    }

    showCuzkLoginDialog(mode, hashes?, requestId?, parId?, budId?: number): Observable<boolean> {
        return this.open(CuzkLoginDialogComponent, {
            hashes: hashes,
            mode: mode,
            requestId: requestId,
            parId: parId,
            budId: budId
        })
    }

    showYesNoDialog(title: string, content: string[], yesLabel: string, noLabel: string): Observable<boolean> {
        return this.open(YesNoDialogComponent, {
            noLabel: noLabel,
            yesLabel: yesLabel,
            title: title,
            content: content,
        })
    }

    showYesNoCancelDialog(title: string, content: string[], yesLabel: string, noLabel: string, cancelLabel: string): Observable<boolean> {
        return this.open(YesNoCancelDialogComponent, {
            noLabel: noLabel,
            yesLabel: yesLabel,
            cancelLabel: cancelLabel,
            title: title,
            content: content,
        })
    }

    showSimpleDialog(title: string, content: string[], buttonLabel: string): Observable<boolean> {
        return this.open(SimpleDialogComponent, {
            title: title,
            content: content,
            buttonLabel: buttonLabel,
        })
    }

    showDateSelectDialog(title, message, buttonLabel, dates): Observable<string> {
        return this.open(DateSelectDialogComponent, {
            title: title,
            message: message,
            buttonLabel: buttonLabel,
            dates: dates
        })
    }


    showSuccessDialog(message: string): Observable<boolean> {
        return this.showSimpleDialog('Úspěch!', [message], 'OK')
    }

    showWarningDialog(message: string | string[]): Observable<boolean> {
        const content = Array.isArray(message) ? message : [message]
        return this.showSimpleDialog('Upozornění', content, 'Rozumím')
    }

    showConfirmationDialog(question: string | string[], title = 'Potvrzení akce'): Observable<boolean> {
        const content = Array.isArray(question) ? question : [question]
        return this.showYesNoDialog(title, content as string[], 'Ano', 'Ne')
    }

    closeAll(): void {
        this.dialog.closeAll()
    }

    // -------------------------------------------------------------------------

    /**
     * Otevře dialog přes CDK a nastaví vstupní data na instanci hned po vytvoření
     * (před prvním change detection / ngOnInit) — zachovává timing semantiku
     * původního ngx-simple-modal `addModal`. `hasBackdrop: false`, protože dialog
     * komponenty si nesou vlastní `.curtain` full-screen overlay.
     */
    private open<R>(component: Type<unknown>, data: object): Observable<R> {
        const ref = this.dialog.open<R>(component, {
            data: data,
            hasBackdrop: false,
            autoFocus: false,
            scrollStrategy: this.overlay.scrollStrategies.noop(),
        })
        if (ref.componentInstance) {
            Object.assign(ref.componentInstance, data)
        }
        return ref.closed as Observable<R>
    }
}
